interface FeatureSlide {
  id: string;
  title: string;
  description: string;
  icon?: string;
  image?: string;
  backgroundGradient?: string; // SVG image URL or gradient
  stats?: {
    label: string;
    value: string;
  }[];
}

interface FeatureCardProps {
  slide: FeatureSlide;
}

export default function FeatureCard({ slide }: FeatureCardProps) {
  const cardStyle = slide.backgroundGradient 
    ? {
        backgroundImage: `url("${slide.backgroundGradient}")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center right',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'local'
      }
    : {};

  return (
    <div 
      className={`rounded-2xl p-12 md:p-16 lg:px-20 lg:py-28 h-full flex flex-col transition-all duration-300 relative overflow-hidden ${
        slide.backgroundGradient 
          ? 'bg-cover bg-center bg-no-repeat' 
          : 'bg-gradient-to-br from-[#4A90E2] to-[#FF7A00]'
      }`}
      style={cardStyle}
    >  
      {slide.image && (
        <div className="mb-6 rounded-xl overflow-hidden relative z-10">
          <img 
            src={slide.image} 
            alt={slide.title}
            className="w-full h-48 md:h-56 object-cover"
          />
        </div>
      )}

      {/* Content */}
      <div className="flex-1 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-4 md:gap-6 relative z-10">
        {slide.icon && (
          <img 
            src={slide.icon} 
            alt={`${slide.title} icon`} 
            className="w-16 h-16 sm:w-16 sm:h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 xl:w-28 xl:h-28 shrink-0 aspect-square object-contain self-start sm:self-center"
          />
        )}
        
        <div className="flex-1 flex flex-col min-w-0">
          <h3 className="text-fluid-4xl lg:text-fluid-5xl font-bold text-white font-space-grotesk leading-[130%] uppercase [text-wrap:balance] mb-5">
            {slide.title}
          </h3>
          
          <p className="text-fluid-base lg:text-fluid-lg xl:text-fluid-base text-white font-manrope font-normal leading-[140%] [text-wrap:pretty] max-w-md lg:max-w-lg xl:max-w-xl">
            {slide.description}
          </p>
        </div>
      </div>
    </div>
  );
}

export type { FeatureSlide };
